import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactFormDialog from '../components/ContactFormDialog';

const PrivacyPolicy = () => {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#09090B] text-white">
      <Header onOpenContactForm={() => setIsContactFormOpen(true)} />

      <div className="pt-32 pb-16 bg-[#09090B]">
        <div className="max-w-7xl mx-auto px-6">
          <Link to="/" className="inline-flex items-center text-[#3B82F6] hover:text-white mb-6 transition-colors text-sm font-semibold">
            <ArrowLeft className="w-4 h-4 mr-2" /> Back to Home
          </Link>
          <h1 className="font-heading text-5xl sm:text-6xl font-semibold tracking-tight leading-none text-white">
            Privacy <span className="font-medium text-[#3B82F6]">Policy</span>
          </h1>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="prose prose-lg prose-invert max-w-none">
          <p className="text-sm text-[#A1A1AA] mb-8">Last updated: February 2026</p>

          <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">1. Introduction</h2>
          <p className="text-[#A1A1AA] leading-relaxed mb-6">
            Trademark Protection For Logos ("we," "us," or "our") operates out of 18952 MacArthur Blvd Suite 100, Irvine, CA 92612. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our logo trademark registration and protection services.
          </p>

          <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">2. Information We Collect</h2>
          <p className="text-[#A1A1AA] leading-relaxed mb-3">We may collect the following types of information:</p>
          <ul className="list-disc pl-6 text-[#A1A1AA] space-y-2 mb-6">
            <li>Personal identification information (name, email address, phone number)</li>
            <li>Business information (company name, business type, industry)</li>
            <li>Trademark and intellectual property details submitted for our services</li>
            <li>Payment and billing information</li>
            <li>Usage data and website analytics</li>
          </ul>

          <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">3. How We Use Your Information</h2>
          <p className="text-[#A1A1AA] leading-relaxed mb-3">We use the information we collect to:</p>
          <ul className="list-disc pl-6 text-[#A1A1AA] space-y-2 mb-6">
            <li>Provide and maintain our trademark registration and legal services</li>
            <li>Process your applications and filings with the USPTO</li>
            <li>Communicate with you about your case and provide updates</li>
            <li>Send marketing communications (with your consent)</li>
            <li>Improve our website and services</li>
            <li>Comply with legal obligations</li>
          </ul>

          <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">4. Data Protection</h2>
          <p className="text-[#A1A1AA] leading-relaxed mb-6">
            We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. All data transmissions are encrypted using SSL technology.
          </p>

          <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">5. Third-Party Sharing</h2>
          <p className="text-[#A1A1AA] leading-relaxed mb-6">
            We do not sell your personal information. We may share your information with government agencies (such as USPTO) as necessary to provide our services, trusted service providers who assist in our operations, or as required by law.
          </p>

          <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">6. Your Rights</h2>
          <p className="text-[#A1A1AA] leading-relaxed mb-6">
            You have the right to access, correct, or delete your personal information. You may also opt out of marketing communications at any time. To exercise these rights, contact us at info@trademarkprotectionforlogos.com.
          </p>

          <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">7. Contact Us</h2>
          <p className="text-[#A1A1AA] leading-relaxed mb-6">
            If you have questions about this Privacy Policy, please contact us at:<br />
            <strong>Trademark Protection For Logos</strong><br />
            18952 MacArthur Blvd Suite 100, Irvine, CA 92612<br />
            Email: info@trademarkprotectionforlogos.com<br />
            Phone: (800) 555-1234
          </p>
        </div>
      </div>

      <Footer onOpenContactForm={() => setIsContactFormOpen(true)} />
      <ContactFormDialog isOpen={isContactFormOpen} onClose={() => setIsContactFormOpen(false)} />
    </div>
  );
};

export default PrivacyPolicy;
